import { useAccounts, useSettings } from '../../contexts';

import { ModalIds } from '../../../../contexts/modals/modals.types';
import { useCallback } from 'react';
import { useModalsContext } from '../../../../contexts';
import { isPrintA4Shown, printAsScreen, useQueryParams } from '../../shared';
import { useTranslation } from 'react-i18next';

const useHeaderHook = () => {
  const [state, setState] = useSettings();
  const { t } = useTranslation('translation', { keyPrefix: 'management.reports.common.header' });
  const { dispatch: modalsDispatch } = useModalsContext();
  const { currentAccount } = useAccounts();
  const { parsed } = useQueryParams();

  const print = (printReport: () => void | Promise<void>) => {
    if (typeof window === 'undefined') return;

    const wasExpanded = state.expanded;
    setState((prev) => ({ ...prev, expanded: true }));

    setTimeout(async () => {
      await printReport();
      if (!wasExpanded) {
        setState((prev) => ({ ...prev, expanded: false }));
      }
    }, 300);
  };

  const handlePrint = () => print(printAsScreen);
  const handlePrintA4 = () => print(() => window.print());

  const handleGenerateModalOpen = useCallback(() => {
    if (currentAccount) {
      modalsDispatch({
        type: 'SHOW_MODAL',
        payload: {
          id: ModalIds.reportsGenerateReport,
          data: {
            reportsGenerateReport: {
              clientEmailOwner: !parsed?.ownership ? currentAccount.ClientEmailOwner : parsed?.email,
            },
          },
        },
      });
    }
  }, [currentAccount, modalsDispatch, parsed?.email, parsed?.ownership]);

  return { t, state, handlePrint, handlePrintA4, isPrintA4Shown: isPrintA4Shown(), handleGenerateModalOpen };
};

export { useHeaderHook };
